import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

// eslint-disable-next-line
import once from 'lodash/once';
// eslint-disable-next-line
import isEmpty from 'lodash/isEmpty';

import { Company } from '@commonTuna/react/objects/Company';
import { Page } from '@commonTuna/react/objects/Page';

import { Location } from '@app/objects/Location';
import { ApplicationState } from '@app/store';

export interface ReduxContext {
	companySettings: Company;
	location: Location;
	blogPageId: number;
	menu: Array<Page>;
}

export const createReduxContext = once(() => React.createContext({} as ReduxContext));

export const useReduxContext: () => ReduxContext = () => {
	const context: ReduxContext = React.useContext<ReduxContext>(createReduxContext());

	if (isEmpty(context)) throw 'Need Redux Context!';

	return context;
};

interface ReduxProviderProps {
	children?: React.ReactNode | ((context: ReduxContext) => React.ReactNode);
}

const ReduxProvider: React.FC<ReduxProviderProps> = ({
	children,
}) => {
	const ReduxProvider = createReduxContext();

	const value = useSelector((state: ApplicationState) => ({
		companySettings: state.location.item.company,
		location: state.location.item,
		blogPageId: state.blogPageId.item,
		menu: state.menu.items,
	}), shallowEqual) as ReduxContext;

	return (
		<>
			<ReduxProvider.Provider value={value}>
				{typeof children === 'function' ? children(value) : children}
			</ReduxProvider.Provider>
		</>
	);
};

export default ReduxProvider;
